module.exports = __webpack_public_path__ + "static/media/team5.37547207.png";